module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Contents",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("contents")]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/ChakraTonicsebk4"
    }
  }, [_vm._v("note to readers")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/ChakraTonicsebk5"
    }
  }, [_vm._v("foreword")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/ChakraTonicsebk6"
    }
  }, [_vm._v("introduction")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/ChakraTonicsebk7"
    }
  }, [_vm._v("why chakra tonics now?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("1.")]), _vm._v("the chakras")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("2.")]), _vm._v("equipment")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("3.")]), _vm._v("ingredients")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("4.")]), _vm._v("root chakra")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("5.")]), _vm._v("sacral chakra")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("6.")]), _vm._v("belly chakra")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("7.")]), _vm._v("heart chakra")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("8.")]), _vm._v("throat chakra")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("9.")]), _vm._v("brow chakra")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("10.")]), _vm._v("crown chakra")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("11.")]), _vm._v("eighth chakra and the hands and feet chakras")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("12.")]), _vm._v("morning tonics")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("13.")]), _vm._v("make your own chakra tonics")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "Toc_Chapter- _idGenBNMarker-1"
  }, [_vm._v("14.")]), _vm._v("chakra rituals and meditations")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("appendix: directory of contributors")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/ChakraTonicsebk23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("about the author")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5498f24a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChakraTonicsebk3.vue
// module id = 69
// module chunks = 0